import { useCallback, useMemo } from 'react';
import { useSelector, useDispatch } from '../../../react-redux';
import { setLivechatPermMap } from '../../../reducers/function';

function useLivechatPermStore() {
  const dispatch = useDispatch();
  const state = useSelector(state => state.get('func'));
  const { livechatPermMap } = useMemo(() => {
    return {
      livechatPermMap: state.get('livechatPermMap')
    };
  }, [state]);

  const updateLivechatPerm = useCallback((data: any) => {
    dispatch(setLivechatPermMap(data));
  }, []);
  return { livechatPermMap, updateLivechatPerm };
}

export default useLivechatPermStore;
